import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2bd0b74b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "u-task-title" }
const _hoisted_5 = { class: "u-title" }
const _hoisted_6 = {
  key: 0,
  class: "u-status-icon u-done"
}
const _hoisted_7 = {
  key: 1,
  class: "u-status-icon u-doing"
}
const _hoisted_8 = { class: "u-task-button" }
const _hoisted_9 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_note_progress = _resolveComponent("note-progress")!
  const _component_CommentsRes = _resolveComponent("CommentsRes")!
  const _component_CardInfoMyNote = _resolveComponent("CardInfoMyNote")!
  const _component_before_upload = _resolveComponent("before-upload")!
  const _component_aio_confirm = _resolveComponent("aio-confirm")!
  const _component_note_strategy = _resolveComponent("note-strategy")!
  const _component_van_action_sheet = _resolveComponent("van-action-sheet")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.parentInfo.action === 5 && $setup.parentInfo.publish_status)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          ($setup.parentInfo.progress !== 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_note_progress, {
                  status: false,
                  progressList: $setup.progressList,
                  currentLevel: $setup.parentInfo.difficulty
                }, null, 8, ["progressList", "currentLevel"]),
                ($setup.parentInfo.progress !== 1)
                  ? (_openBlock(), _createBlock(_component_CommentsRes, {
                      key: 0,
                      progress: $setup.parentInfo.progress,
                      commentInfo: $setup.commentInfo
                    }, null, 8, ["progress", "commentInfo"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_CardInfoMyNote, {
                  progress: $setup.parentInfo.progress,
                  reportDataMap: $setup.reportDataMap,
                  column_id: $setup.parentInfo.column_id,
                  card_id: $setup.parentInfo.card_id,
                  uuid: $setup.parentInfo.uuid,
                  notePicList: $setup.notePicList,
                  commentInfo: $setup.commentInfo,
                  onOpenNoteStrategy: $setup.showStrategy,
                  onNoteDeleteDone: $setup.noteDeleteDone,
                  onResetStar3NoteList: $setup.resetStar3NoteList,
                  onOpenUpgradeModal: $setup.callUploadAction
                }, null, 8, ["progress", "reportDataMap", "column_id", "card_id", "uuid", "notePicList", "commentInfo", "onOpenNoteStrategy", "onNoteDeleteDone", "onResetStar3NoteList", "onOpenUpgradeModal"])
              ]))
            : (_openBlock(), _createBlock(_component_before_upload, {
                key: 1,
                onCallUploadAction: $setup.callUploadAction,
                onOpenNoteStrategy: $setup.showStrategy,
                reportDataMap: $setup.reportDataMap
              }, null, 8, ["onCallUploadAction", "onOpenNoteStrategy", "reportDataMap"]))
        ]))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($props.taskList, (tile, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `task-list-${index}`
          }, [
            ($props.cardType !== 2 || ($props.cardType === 2 && tile.difficulty == $props.difficulty))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "m-task-tile",
                  onClick: ($event: any) => ($setup.onClickTaskTile(tile))
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["u-task-difficulty", { 'u-nostar': $props.cardType !== 2 }])
                  }, _toDisplayString($props.cardType === 2 ? `${tile.difficulty}星任务` : "学习任务"), 3),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, _toDisplayString(tile.title), 1),
                    (tile.finish_status === 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6))
                      : _createCommentVNode("", true),
                    (tile.resource_type == 4 && tile.finish_status !== 1 && tile.status >= 2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    (tile.btnEnable)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass(["u-button", {
              disabled: !tile.btnEnable,
              done:
                tile.finish_status === 1 ||
                (tile.resource_type == 4 && !tile.finish_status && tile.status >= 2),
            }]),
                          onClick: _withModifiers(($event: any) => ($setup.onClickBtn(tile)), ["stop"])
                        }, _toDisplayString(tile.btnText), 11, _hoisted_9))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: _normalizeClass(["u-button", { disabled: !tile.btnEnable, done: tile.finish_status === 1 }])
                        }, _toDisplayString(tile.btnText), 3))
                  ])
                ], 8, _hoisted_3))
              : _createCommentVNode("", true)
          ]))
        }), 128)),
    _createVNode(_component_aio_confirm, {
      visible: $setup.confirmVisible,
      confirmInfo: $setup.confirmInfo
    }, null, 8, ["visible", "confirmInfo"]),
    _createVNode(_component_van_action_sheet, {
      show: $setup.strategyVisible,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => (($setup.strategyVisible) = $event)),
      title: "笔记攻略",
      closeable: "",
      class: "startegy-action-sheet"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_note_strategy, {
          firstShow: $setup.strategyFirstShow,
          progress: $setup.parentInfo.progress,
          reportDataMap: $setup.reportDataMap,
          style: {"height":"'40%'"},
          onCallUploadAction: $setup.callUploadAction
        }, null, 8, ["firstShow", "progress", "reportDataMap", "onCallUploadAction"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_action_sheet, {
      show: $setup.callUploadActionVisible,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => (($setup.callUploadActionVisible) = $event)),
      onSelect: $setup.handleSelectUploadAction,
      onCancel: $setup.handleUploadActionCancel,
      actions: $setup.callUploadActions,
      "cancel-text": "取消",
      "lock-scroll": "",
      "close-on-click-action": true,
      class: "upload-action-sheet"
    }, null, 8, ["show", "onSelect", "onCancel", "actions"])
  ], 64))
}